import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "40px"
      }}
    >
      <h1 style={{ fontSize: "60px", marginBottom: "10px" }}>
        404
      </h1>

      <p style={{ fontSize: "18px", color: "#666", marginBottom: "20px" }}>
        This page does not exist.
      </p>

      <Link
        to="/"
        style={{
          background: "#f97316",
          padding: "10px 20px",
          color: "#000",
          textDecoration: "none"
        }}
      >
        Go Back Home
      </Link>
    </div>
  );
}
